import { Lightning, Utils, Storage, Router } from "@lightningjs/sdk";
import { Carousel } from "@lightningjs/ui";

import RadiostationCard from "../../components/radiostations/radiostationCard";
import { Store } from "../../services/app.store.service";
import { pathNames } from "../../lib/routes";
import { gridHeight, gridWidth } from "../../services/grid.service";

import { ReportingService, TrackingAction, ViewNames } from "../../services/reporting.service";

import { nowNext } from "../../services/data.service";
import { RadiostationsService } from "../../services/radiostations.service";
import { changeArrayForCarousel, getFormatted2NumbersIndex, truncate } from "../../lib/util";
import { NumericKeyPressService } from "../../services/numeric.keyPress.service";
import { config } from "../../config";

export default class Radiostations extends Lightning.Component {
  static _template() {
    return {
      ...super._template(),
      BackgroundInactive: {
        rect: true,
        w: 24 * gridWidth,
        h: 24 * gridHeight,
        color: 0xff222222,
      },
      BackgroundActive: {
        rect: true,
        w: 24 * gridWidth,
        h: 24 * gridHeight,
        color: 0xff000000,
      },
      Logo: {
        x: 11.5 * gridWidth,
        y: 1 * gridHeight,
        LogoImage: {
          w: 2 * gridWidth,
          h: 1 * gridHeight,
          Img: {
            w: 2 * gridWidth,
            h: 1 * gridHeight,
            src: Utils.asset("images/xite-music-logo.png"),
          },
        },
      },
      RightPrompting: {
        w: 2 * gridWidth,
        h: 1 * gridHeight,
        x: 21 * gridWidth,
        y: 1 * gridHeight,
        FocusedRadiostationIndex: {
          w: 1 * gridWidth - 10,
          h: 1 * gridHeight,
          text: {
            text: "",
            fontFace: "Roboto-Bold",
            fontSize: 40,
            lineHeight: gridHeight,
            textColor: 0xffffffff,
            verticalAlign: "middle",
            textAlign: "right",
          },
        },
        TotalRadiostations: {
          w: 1 * gridWidth,
          h: 1 * gridHeight,
          x: 1 * gridWidth,
          text: {
            text: "",
            fontFace: "Roboto-Regular",
            fontSize: 40,
            lineHeight: gridHeight,
            textColor: 0xff545454,
            verticalAlign: "middle",
            textAlign: "left",
          },
        },
      },
      PlayingNowWrapper: {
        w: 5 * gridWidth,
        h: 2 * gridHeight,
        x: 1 * gridWidth,
        y: 20 * gridHeight,
        PlayerNowLabel: {
          w: 5 * gridWidth,
          h: 1 * gridHeight,
          y: -0.3 * gridHeight,
          text: {
            text: "Now",
            fontFace: "Roboto-Regular",
            fontSize: 24,
            lineHeight: gridHeight,
            textColor: 0xff7d7d7d,
            verticalAlign: "middle",
            textAlign: "right",
          },
        },
        PlayerNowTitle: {
          w: 5 * gridWidth,
          h: 1 * gridHeight,
          y: 0.4 * gridHeight,
          text: {
            text: "",
            fontFace: "Roboto-Bold",
            fontSize: 24,
            lineHeight: gridHeight,
            textColor: 0xffffffff,
            verticalAlign: "middle",
            textAlign: "right",
          },
        },
        PlayerNowArtist: {
          w: 5 * gridWidth,
          h: 1 * gridHeight,
          y: 1.1 * gridHeight,
          text: {
            text: "",
            fontFace: "Roboto-Regular",
            fontSize: 24,
            lineHeight: gridHeight,
            textColor: 0xffffffff,
            verticalAlign: "middle",
            textAlign: "right",
          },
        },
      },
      PlayingNextWrapper: {
        w: 5 * gridWidth,
        h: 2 * gridHeight,
        x: 18 * gridWidth,
        y: 20 * gridHeight,
        PlayerNextLabel: {
          w: 5 * gridWidth,
          h: 1 * gridHeight,
          y: -0.3 * gridHeight,
          text: {
            text: "Next",
            fontFace: "Roboto-Regular",
            fontSize: 24,
            lineHeight: gridHeight,
            textColor: 0xff7d7d7d,
            verticalAlign: "middle",
            textAlign: "left",
          },
        },
        PlayerNextTitle: {
          w: 5 * gridWidth,
          h: 1 * gridHeight,
          y: 0.4 * gridHeight,
          text: {
            text: "",
            fontFace: "Roboto-Bold",
            fontSize: 24,
            lineHeight: gridHeight,
            textColor: 0xffffffff,
            verticalAlign: "middle",
            textAlign: "left",
          },
        },
        PlayerNextArtist: {
          w: 5 * gridWidth,
          h: 1 * gridHeight,
          y: 1.1 * gridHeight,
          text: {
            text: "",
            fontFace: "Roboto-Regular",
            fontSize: 24,
            lineHeight: gridHeight,
            textColor: 0xffffffff,
            verticalAlign: "middle",
            textAlign: "left",
          },
        },
      },
      CenterPromptings: {
        w: 8 * gridWidth,
        h: 2 * gridHeight,
        x: 8 * gridWidth,
        y: 20 * gridHeight,
        CurrentRadiostationLabel: {
          w: 8 * gridWidth,
          h: 1 * gridHeight,
          y: -0.3 * gridHeight,
          text: {
            text: "Current station",
            fontFace: "Roboto-Regular",
            fontSize: 24,
            lineHeight: gridHeight,
            textColor: 0xff7d7d7d,
            verticalAlign: "middle",
            textAlign: "center",
          },
        },
        CurrentRadiostationTitle: {
          w: 8 * gridWidth,
          h: 1.4 * gridHeight,
          y: 0.7 * gridHeight,
          text: {
            text: "",
            fontFace: "Roboto-Bold",
            fontSize: 36,
            lineHeight: gridHeight,
            textColor: 0xffffffff,
            verticalAlign: "middle",
            textAlign: "center",
          },
        },
        DownIndicator: {},
        RadiostationDescription: {
          w: 24 * gridWidth,
          h: 3 * gridHeight,
          y: 16 * gridHeight,
          alpha: 1,
          rect: true,
          color: 0xffff4500,
          RadiostationFocusedDescription: {
            alpha: 1,
            w: 24 * gridWidth,
            text: {
              text: "",
              fontFace: "Roboto-Italic",
              fontSize: 24,
              lineHeight: 1 * gridHeight,
              textColor: 0xffffffff,
              verticalAlign: "middle",
              textAlign: "center",
            },
          },
        },
      },
      Carousel: {
        y: 6 * gridHeight,
        x: (24 * gridWidth - 12 * gridHeight) / 2,
        w: 24 * gridWidth,
        h: 12 * gridHeight,
        scroll: 0,
        gcThreshold: 10,
        type: Carousel,
        direction: "row",
        signals: { onIndexChanged: true },
      },
    };
  }

  get activeItem() {
    return this.tag("Carousel");
  }

  initCarouselWithIndex(index) {
    let previouslyActiveRadiostationIndex = 0;
    if (typeof index !== "undefined") {
      previouslyActiveRadiostationIndex = index;
    } else {
      previouslyActiveRadiostationIndex = RadiostationsService.getPreviouslyActiveRadiostation();
    }

    this.currentRadiostationIndexToShow = getFormatted2NumbersIndex(
      previouslyActiveRadiostationIndex
    );

    this.radiostationsToRender = changeArrayForCarousel(
      this.radiostations,
      previouslyActiveRadiostationIndex
    );

    Store.radiostationsToRender = this.radiostationsToRender;

    this.renderCarouselWithItems(this.radiostationsToRender);

    this.activateRadiostation(0);
  }

  renderCarouselWithItems(radiostationsToRender) {
    let items = [];
    for (let i = 0; i < radiostationsToRender.length; i++) {
      items.push({
        w: 12 * gridHeight - 2,
        h: 12 * gridHeight,
        margin: 1,
        activeItem: i === 0 ? true : false,
        type: RadiostationCard,
        radiostationName: this.radiostationsToRender[i].name,
        radiostationDescription: this.radiostationsToRender[i].description,
        radiostationImage: `${config.appConfig.baseImageUrl}/${this.radiostationsToRender[i].id}.jpg`,
        index: i,
      });
    }
    this.tag("Carousel").items = items;
  }

  onIndexChanged() {
    this.activeCarouselIndex = this.tag("Carousel").currentItem.index;

    if (this.activeCarouselIndex !== 0) {
      this.enableActiveMode();
    }

    this.currentRadiostationIndexToShow = getFormatted2NumbersIndex(
      this.radiostationsToRender[this.activeCarouselIndex].id
    );

    this.updateCounters(this.currentRadiostationIndexToShow);

    if (this.activeCarouselIndex === this.activeRadiostationIndex) {
      this.tag("BackgroundActive").patch({
        smooth: {
          alpha: 1,
        },
      });
    } else {
      this.tag("BackgroundActive").patch({
        smooth: {
          alpha: 0,
        },
      });
    }
  }

  updateCounters(indexToShow) {
    this.tag("FocusedRadiostationIndex").patch({
      text: {
        text: indexToShow,
      },
    });

    this.tag("TotalRadiostations").patch({
      text: {
        text: this.radiostations.length,
      },
    });
  }

  activateRadiostation(index) {
    let radiostationToActivate = this.radiostationsToRender[index];

    this.activeRadiostationIndex = index;

    this.currentRadiostationIndexToShow = getFormatted2NumbersIndex(radiostationToActivate.id);
    this.updateCounters(this.currentRadiostationIndexToShow);

    this.tag("Carousel").currentItem.activeItem = true;
    RadiostationsService.setCurrentRadiostation(radiostationToActivate);
    NumericKeyPressService.changeChannelTo(radiostationToActivate.channel);

    this.tag("BackgroundActive").patch({
      smooth: {
        alpha: 1,
      },
    });

    this.tag("CurrentRadiostationTitle").patch({
      text: {
        text: radiostationToActivate.name,
      },
    });
    this.callNowNext();
    this.startFetchingNowNext();

    let customTrackingData = {
      channelName: radiostationToActivate.name,
      channelId: radiostationToActivate.channel,
      playerType: "channel",
      sendImmediate: true,
    };
    ReportingService.silentTrack({
      action: TrackingAction.PlayerStart,
      customData: customTrackingData,
      sendImmediate: true,
    });
  }

  _getFocused() {
    return this.activeItem;
  }

  _enable() {
    ReportingService.trackViewChange(Storage.get("sourceViewName"), ViewNames.Radiostations, false);

    Storage.set("sourceViewName", ViewNames.Radiostations);

    this.radiostations = Store.radiostations;
    this.initCarouselWithIndex();

    this.startFetchingNowNext();

    this.startInactiveModeTimeout();
  }

  enableInactiveMode() {
    if (this.activeCarouselIndex !== 0) {
      this.tag("Carousel").setIndex(0);
      this._refocus();
    }

    this.isApplicationInactive = true;

    let fullCycleAnimationTime = 0.5; //in seconds

    this.LogoSlidingDownAnimation = this.tag("Logo").animation({
      duration: fullCycleAnimationTime,
      repeat: 0,
      stopMethod: "immediate",
      actions: [
        {
          p: "y",
          v: {
            0: 1 * gridHeight,
            1: 10 * gridHeight,
          },
        },
      ],
    });

    this.CenterPromptingsUpAnimation = this.tag("CenterPromptings").animation({
      duration: fullCycleAnimationTime,
      repeat: 0,
      stopMethod: "immediate",
      actions: [
        {
          p: "y",
          v: {
            0: 20 * gridHeight,
            1: 10 * gridHeight,
          },
        },
      ],
    });

    this.NowSlidingUpAnimation = this.tag("PlayingNowWrapper").animation({
      duration: fullCycleAnimationTime,
      repeat: 0,
      stopMethod: "immediate",
      actions: [
        {
          p: "y",
          v: {
            0: 20 * gridHeight,
            1: 11 * gridHeight,
          },
        },
      ],
    });

    this.NextSlidingUpAnimation = this.tag("PlayingNextWrapper").animation({
      duration: fullCycleAnimationTime,
      repeat: 0,
      stopMethod: "immediate",
      actions: [
        {
          p: "y",
          v: {
            0: 20 * gridHeight,
            1: 11 * gridHeight,
          },
        },
      ],
    });

    setTimeout(() => {
      this.application.emit("appInactive");
      // CHANGING PROMPTINGS AND LOGO POSITION
      this.LogoSlidingDownAnimation.start();
      this.CenterPromptingsUpAnimation.start();
      this.NowSlidingUpAnimation.start();
      this.NextSlidingUpAnimation.start();
    }, 200);

    this.patch({
      RightPrompting: {
        smooth: {
          alpha: 0,
        },
      },
    });
  }

  disableInactiveMode() {
    setTimeout(() => {
      this.application.emit("appActive");
    }, 1);

    this.isApplicationInactive = false;
    this.LogoSlidingDownAnimation.stop();
    this.CenterPromptingsUpAnimation.stop();
    this.NowSlidingUpAnimation.stop();
    this.NextSlidingUpAnimation.stop();

    let fullCycleAnimationTime = 0.01; //in seconds
    let finalLogoYPosotion = this.tag("Logo").finalY;
    let passedInPercentage = finalLogoYPosotion / (10 * gridHeight);

    let animationTime = passedInPercentage * fullCycleAnimationTime;

    // CHANGING PROMPTINGS AND LOGO POSITION
    this.LogoSlidingUpAnimation = this.tag("Logo").animation({
      duration: animationTime,
      repeat: 0,
      stopMethod: "immediate",
      actions: [
        {
          p: "y",
          v: {
            0: this.tag("Logo").finalY,
            1: 1 * gridHeight,
          },
        },
      ],
    });

    this.CenterPromptingsDownAnimation = this.tag("CenterPromptings").animation({
      duration: animationTime,
      repeat: 0,
      stopMethod: "immediate",
      actions: [
        {
          p: "y",
          v: {
            0: this.tag("CenterPromptings").finalY,
            1: 20 * gridHeight,
          },
        },
      ],
    });

    this.NowSlidingDownAnimation = this.tag("PlayingNowWrapper").animation({
      duration: animationTime,
      repeat: 0,
      stopMethod: "immediate",
      actions: [
        {
          p: "y",
          v: {
            0: this.tag("PlayingNowWrapper").finalY,
            1: 20 * gridHeight,
          },
        },
      ],
    });

    this.NextSlidingDownAnimation = this.tag("PlayingNextWrapper").animation({
      duration: animationTime,
      repeat: 0,
      stopMethod: "immediate",
      actions: [
        {
          p: "y",
          v: {
            0: this.tag("PlayingNextWrapper").finalY,
            1: 20 * gridHeight,
          },
        },
      ],
    });

    this.LogoSlidingUpAnimation.start();
    this.CenterPromptingsDownAnimation.start();
    this.NowSlidingDownAnimation.start();
    this.NextSlidingDownAnimation.start();

    this.patch({
      RightPrompting: {
        smooth: {
          alpha: 1,
        },
      },
    });
  }

  enableActiveMode() {
    if (this.isApplicationInactive) {
      this.disableInactiveMode();
    }
    this.startInactiveModeTimeout();
  }

  startInactiveModeTimeout() {
    if (this.inactivityTimeout) {
      clearTimeout(this.inactivityTimeout);
    }

    this.inactivityTimeout = setTimeout(() => {
      this.enableInactiveMode();
    }, Store.inactivityTimeout);
  }

  startFetchingNowNext() {
    if (this.nowNextInteval) {
      clearInterval(this.nowNextInteval);
    }

    this.nowNextInteval = setInterval(() => {
      this.callNowNext();
    }, 5000);
  }

  callNowNext() {
    nowNext(this.radiostationsToRender[this.activeRadiostationIndex].url)
      .then(nowNextResponse => {
        this.updateNowNext(nowNextResponse);
      })
      .catch(error => {
        this.updateNowNext({});
        ReportingService.silentTrack({
          action: TrackingAction.NowNextFailure,
          customAssetId: this.radiostationsToRender[this.activeRadiostationIndex].channel,
          customChannelName: this.radiostationsToRender[this.activeRadiostationIndex].name,
          sendImmediate: true,
        });
      });
  }

  updateNowNext(nowNextObject) {
    if (nowNextObject.nowPlaying) {
      this.tag("PlayerNowLabel").patch({
        smooth: {
          alpha: 1,
        },
      });

      this.tag("PlayerNowTitle").patch({
        smooth: {
          alpha: 1,
        },
        text: {
          text: truncate(nowNextObject.nowPlaying.title, 35),
        },
      });

      this.tag("PlayerNowArtist").patch({
        smooth: {
          alpha: 1,
        },
        text: {
          text: truncate(nowNextObject.nowPlaying.artist, 35),
        },
      });
    } else {
      this.tag("PlayerNowLabel").patch({
        smooth: {
          alpha: 0,
        },
      });

      this.tag("PlayerNowTitle").patch({
        smooth: {
          alpha: 0,
        },
      });

      this.tag("PlayerNowArtist").patch({
        smooth: {
          alpha: 0,
        },
      });
    }

    if (nowNextObject.next) {
      this.tag("PlayerNextLabel").patch({
        smooth: {
          alpha: 1,
        },
      });

      this.tag("PlayerNextTitle").patch({
        smooth: {
          alpha: 1,
        },
        text: {
          text: truncate(nowNextObject.next.title, 35),
        },
      });

      this.tag("PlayerNextArtist").patch({
        smooth: {
          alpha: 1,
        },
        text: {
          text: truncate(nowNextObject.next.artist, 35),
        },
      });
    } else {
      this.tag("PlayerNextLabel").patch({
        smooth: {
          alpha: 0,
        },
      });

      this.tag("PlayerNextTitle").patch({
        smooth: {
          alpha: 0,
        },
      });

      this.tag("PlayerNextArtist").patch({
        smooth: {
          alpha: 0,
        },
      });
    }
  }

  _handleDown() {
    this.enableActiveMode();
    this.tag("Carousel").setIndex(0);
    return false;
  }

  _handleKey() {
    this.enableActiveMode();
    return false;
  }

  _handleBack() {
    Router.navigate(pathNames.Exit);
  }

  _handleEnter() {
    this.enableActiveMode();
    this.initCarouselWithIndex(this.radiostationsToRender[this.activeCarouselIndex].id - 1);
  }

  _disable() {
    clearInterval(this.nowNextInteval);
    clearTimeout(this.inactivityTimeout);
  }
}
